import GenericTable from "../../components/common/genericTable";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {
  changeBatchTypeStatus, clearAddSchoolAlerts,
  clearChangeBatchTypeStatusErrors,
  clearSchoolDemographicInfo,
  fetchSchools
} from "../../actions/schools";
import SearchField from "../../components/common/searchField";
import {setLiveRegionText} from "../../actions/app";
import ToggleButton from "../../components/common/toggleButton";
import ResultsCount from "../../components/common/resultsCount";
import Pagination from "../../components/common/pagination";
import {DEFAULT_RESULTS_PER_PAGE, MESSAGES} from "../../constants";
import Alert from "../../components/common/alert";
import {userCanAccess} from "../../utils/users";
import {useNavigate} from "react-router-dom";

let columns =  [
  {name: 'atpCode', label: 'ATP Code', sortable: true},
  {name: 'name', label: 'School Name', sortable: true},
  {name: 'city', label: 'City', sortable: true},
  {name: 'batchType', label: 'Type', sortable: true},
  {name: 'setType', label: 'Set Type'}
];


const Schools = (props) => {
  const {
    addSchoolAlert
  } = props;

  const searchMessage = 'Search completed.';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchFilter, setSearchFilter] = useState('');
  const [liveRegionMessage, setLiveRegionMessage] = useState('');
  const currentDistrict = useSelector((store) => store.districts.currentDistrict);
  const currentUserComposite = useSelector((store) => store.session.currentUserComposite);
  const batchTypeChangeErrors = useSelector((store) => store.schools.batchTypeChangeErrors)
  const [batchTypeStatus, setBatchTypeStatus] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  let emptyMessage = MESSAGES.GENERIC_TABLE.noDataAvailable;

  const resultsPerPage = DEFAULT_RESULTS_PER_PAGE;

  const firstItem = (currentPage === 1) ? 0 : (currentPage - 1) * resultsPerPage;

  useEffect(() => {
    if (currentDistrict) {
      dispatch(fetchSchools(currentDistrict));
      dispatch(clearSchoolDemographicInfo())
    }
  }, [currentUserComposite, dispatch, currentDistrict]);

  let items = useSelector((store) => store.schools.schools);

  if (items && items.length > 0 && batchTypeStatus.length === 0) {
    const newBatchTypeStatus = [];

    items.forEach((item, idx) => {
      newBatchTypeStatus[idx] = {
        'atpCode': item.atpCode,
        'batchType': item.batchType
      };
    })

    setBatchTypeStatus(newBatchTypeStatus);
  }


  function prepareColumns () {
    return columns.map((column) => {
      return processColumn(column);
    });
  }

  function processColumn(column) {
    switch (column.name) {
      case 'atpCode':
        if (userCanAccess(currentUserComposite, 'school-profile')) {
          column.onDisplay = (item, column) => {
            const atpUrl = `/#/school-profile?atpCode=${item.atpCode}`;
            return <a href={atpUrl}>{item.atpCode}</a>;
          };
        }
        return column;
      case 'batchType':
        if (userCanAccess(currentUserComposite, 'school-change-batch-type')) {
          column.onDisplay = (item, column) => {
            const schoolBatchType = batchTypeStatus.find(element => element.atpCode === item.atpCode);
            return (schoolBatchType) ? schoolBatchType.batchType : 'N/A';
          }
        }
        return column;
      case 'setType':
        return (userCanAccess(currentUserComposite, 'school-change-batch-type')) ? column : false;
      default:
        return column;
    }
  }

  const [sortColumn, setSortColumn] = useState('name');
  const [sortDirection, setSortDirection] = useState('');

  function sortSchools(a,b) {
    switch (sortColumn) {
      case 'batchType':
        const batchTypeStatusA = batchTypeStatus.find(element => element.atpCode === a['atpCode']);
        const batchTypeStatusB = batchTypeStatus.find(element => element.atpCode === b['atpCode']);

        const sortValueA = (batchTypeStatusA) ? batchTypeStatusA[sortColumn] : null;
        const sortValueB = (batchTypeStatusB) ? batchTypeStatusB[sortColumn] : null;

        return compareSortValues(sortValueA, sortValueB);
      default:
        return compareSortValues(a[sortColumn], b[sortColumn], true);
    }
  }

  // basicCharsOnly only compares alphanumeric lowercase characters
  function compareSortValues(sortValueA, sortValueB, basicCharsOnly = false) {
    let valueA = sortValueA;
    if ((typeof sortValueA === 'string') && basicCharsOnly) {
      valueA = sortValueA.toLowerCase().replace(/\W/g, '');
    }

    let valueB = sortValueB;
    if ((typeof sortValueB === 'string') && basicCharsOnly) {
      valueB = sortValueB.toLowerCase().replace(/\W/g, '');
    }

    if (valueA === null) {
      return (sortDirection === 'ascending') ? 1 : -1;
    }

    if (valueB === null) {
      return (sortDirection === 'ascending') ? -1 : 1;
    }

    if (valueA < valueB) {
      return (sortDirection === 'ascending') ? 1 : -1;
    }
    if (valueA > valueB) {
      return (sortDirection === 'ascending') ? -1 : 1;
    }

    return 0;
  }

  function checkFilters(item) {
    if (searchFilter) {
      const searchTerm = searchFilter.toLowerCase();

      if (item.atpCode.indexOf(searchTerm) < 0 && item.name.toLowerCase().indexOf(searchTerm) < 0 && item.city.toLowerCase().indexOf(searchTerm) < 0) {
        return false;
      }
    }

    return true;
  }

  function filterTable(filterAction, filterValue, newLiveRegionMessage) {
    filterAction(filterValue);
    setLiveRegionMessage(newLiveRegionMessage);
    setCurrentPage(1);
  }

  let fullLiveRegionMessage = '';

  function processSchools() {
    let filteredItems = items.filter(checkFilters);

    let sortedItems = (sortDirection) ? filteredItems.sort(sortSchools)  : filteredItems;

    if (liveRegionMessage) {
      fullLiveRegionMessage = `${liveRegionMessage} ${filteredItems.length} results returned`;
    }

    if (items.length !== filteredItems.length && filteredItems.length === 0) {
      emptyMessage = MESSAGES.GENERIC_TABLE.noResultsFound;
    }

    return addSetTypes(sortedItems);
  }

  const filteredItems = (items) ? processSchools() : [];

  const pageItems = () => {
    return filteredItems.slice(firstItem, lastItem());
  }

  const resultsFirstItem = () => {
    return (filteredItems.length > 0) ? firstItem + 1 : 0;
  }

  const lastItem = () => {
    if (filteredItems.length <= resultsPerPage) {
      return filteredItems.length;
    } else {
      const lastItem = firstItem + resultsPerPage;

      return (lastItem <= filteredItems.length) ? lastItem: filteredItems.length;
    }
  }

  const totalPages = Math.ceil((filteredItems.length / resultsPerPage));

  function changeSort(newSortDirection, newSortColumn) {
    setSortDirection(newSortDirection);

    if (newSortColumn !== sortColumn) {
      setSortColumn(newSortColumn);
    }
  }

  function addSetTypes(items) {
    return items.map((item, idx) => {
      item.setType = addSetType(item, idx);
      return item;
    });
  }

  function addSetType(item, idx, isChecked = false) {
    const name = `setType-${idx}`;


    const currentBatchTypeIndex = batchTypeStatus.findIndex(element => element.atpCode === item.atpCode);
    const currentBatchType = batchTypeStatus[currentBatchTypeIndex];

    if (!currentBatchType) {
      return;
    }

    const buttonLabel = (currentBatchType['batchType'] === 'A') ? 'Set to manual' : 'Set to auto';

    const onChange = () => {
      if (userCanAccess(currentUserComposite, 'school-change-batch-type')) {
        const newBatchTypeStatus = [...batchTypeStatus];

        currentBatchType['batchType'] = (currentBatchType['batchType'] === 'A') ? 'M' : 'A';

        newBatchTypeStatus[currentBatchTypeIndex] = currentBatchType;

        dispatch(changeBatchTypeStatus(item, currentBatchType['batchType']));
        setBatchTypeStatus(newBatchTypeStatus);
      }
    }

    item.batchType = currentBatchType['batchType'];

    return (
      <ToggleButton name={name} label={buttonLabel} idx={idx} onChange={onChange} batchTypeStatus={batchTypeStatus}/>
    );
  }

  const clickAddSchool = () => {
    dispatch(clearAddSchoolAlerts());
    navigate('/add-school');
  }

  useEffect(() => {
    if (fullLiveRegionMessage) {
      dispatch(setLiveRegionText(fullLiveRegionMessage));
    }
  });

  return (
    <div className='main-content'>
      <div className='manage-schools-header'>{currentDistrict && currentDistrict.name}</div>
      <div className='manage-schools-alerts'>
        {(addSchoolAlert) && <Alert messageType={'success'} onDismiss={() => dispatch(clearAddSchoolAlerts())}>{MESSAGES.SCHOOLS.addSchoolSuccess}</Alert>}
        {(batchTypeChangeErrors) && <Alert messageType='error' onDismiss={() => dispatch(clearChangeBatchTypeStatusErrors())}>{MESSAGES.SCHOOLS.changeBatchTypeStatusError}</Alert>}
      </div>
      <div className='manage-schools-container'>
        <div className="table-controls">
          <div className="search-and-add-controls">
            <SearchField
              label='Search ATPCode, Name, etc.'
              placeholder='Search ATPCode, Name, etc.'
              submitAction={(searchValue) => {filterTable(setSearchFilter, searchValue, searchMessage)}}
            />
            {userCanAccess(currentUserComposite, 'school-profile') ? <button className='tes-button sr-hide' onClick={() => clickAddSchool()}>+ New School</button> : ''}
          </div>

        </div>
        <GenericTable tableData={pageItems()} cols={prepareColumns(columns)} emptyMessage={emptyMessage} sortAction={(newSortDirection, newSortColumn) => {changeSort(newSortDirection, newSortColumn)}}/>
        <div className='pagination-controls'>
          <ResultsCount first={resultsFirstItem()} last={lastItem()} total={filteredItems.length} preFilterTotal={(items && filteredItems.length !== items.length) ? items.length : null}/>
          <div className='pagination'>
            <Pagination totalPages={totalPages} currentPage={currentPage} pagesToShow={3} changeFunction={setCurrentPage} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Schools;
